import { createAction } from "redux-actions";

export const FETCH_ADVERTISEMENTS = "FETCH_ADVERTISEMENTS";
export const fetchAdvertisements = createAction(FETCH_ADVERTISEMENTS);

export const FETCH_ADVERTISEMENTS_FAILURE = "FETCH_ADVERTISEMENTS_FAILURE";
export const fetchAdvertisementsFailure = createAction(FETCH_ADVERTISEMENTS_FAILURE);

export const FETCH_ADVERTISEMENTS_REQUESTED = "FETCH_ADVERTISEMENTS_REQUESTED";
export const fetchAdvertisementsRequested = createAction(FETCH_ADVERTISEMENTS_REQUESTED);

export const FETCH_ADVERTISEMENTS_SUCCESS = "FETCH_ADVERTISEMENTS_SUCCESS";
export const fetchAdvertisementsSuccess = createAction(FETCH_ADVERTISEMENTS_SUCCESS);
